/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Completed_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Batch export completed successfully" |
*
* @param {Batch_Subtitle_Export_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_completed_successfully = /** @type {((inputs?: Batch_Subtitle_Export_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lot terminée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Batch-Export erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione batch completata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пакетный экспорт успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La exportación por lotes se completó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチエクスポートが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात सफलतापूर्वक पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Batch export completed successfully")
});